import React from "react";
import { Route, Switch } from "react-router-dom";
// import UserMenu from "src/Components/UserMenu";
import NotFound from "src/Routes/NotFound";
import styled from "styled-components";
import Home from "../Home";
import Me from "../Me";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  min-height: 100vh;
  flex-direction: row;
  background-color: ${(props) => props.theme.extraLightGreyColor};
`;

const TheLayout: React.SFC<any> = ({ userInfo, isAdmin }) => {
  return (
    <Container>
      {/* <UserMenu isAdmin={isAdmin} /> */}
      <Switch>
        <Route exact path="/" component={() => <Home isAdmin={isAdmin} />} />
        <Route path="/me" component={Me} />
        <Route component={NotFound} />
      </Switch>
    </Container>
  );
};
export default TheLayout;
